import { useContext, useEffect, useState } from "react";
import AsideV2 from "../../../components/asidev2/AsideV2";
import "../home/Styles.css"
import { getAllUsers, sendRedefinitionPassword } from "../../../hooks/firebase";
import HeaderV2 from "../../../components/adminV2/header/Header";
import { AuthContext } from "../../../context/AuthContext";

export default function UsuariosV2(){
    const { userData } = useContext(AuthContext);
    const [data, setData] = useState(false)
    
        useEffect(() => {
            async function load() {
                let data = await getAllUsers();
                setData(data)
            }
            load()
        },[])

    return <div>
        <AsideV2 />
        <main className="main-wrapper">
            <HeaderV2 />
            {data && (
                <section className="section py-5">
                    <div className="container-fluid">
                    <h2 className="mb-4">Lista de Usuários</h2>

                    <div className="accordion" id="userAccordion">
                        {data.map((user, index) => {
                        const {
                            uid,
                            photoURL,
                            name,
                            email,
                            type,
                            registration,
                            firstFreeProperty,
                            firstHighlightProperty,
                            websiteUsage,
                            appusage,
                        } = user;

                        const userImage =
                            photoURL?.trim() !== ""
                            ? photoURL
                            : false;

                        return (
                            <div className="accordion-item border-0 border-bottom" key={uid || index}>
                            <h2 className="accordion-header">
                                <button
                                className="accordion-button collapsed bg-white"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapseUser${index}`}
                                aria-expanded="false"
                                aria-controls={`collapseUser${index}`}
                                >
                                <div className="container-fluid px-0">
                                    <div className="row align-items-center text-start w-100">
                                    <div className="col-md-1 col-2 d-flex">
                                        
                                        {userImage ?
                                            <img
                                                src={userImage}
                                                className="rounded-circle"
                                                alt="Foto do usuário"
                                                width="50"
                                                height="50"
                                                style={{ backgroundColor: "white" }}
                                            />
                                            :
                                            <div style={{ backgroundColor: "gray", height: 50, width: 50 }} className="rounded-circle">

                                            </div>
                                        }
                                    </div>

                                    <div className="col-md-3 col-10 fw-semibold">
                                        {name || "Nome não informado"}
                                    </div>

                                    <div className="col-md-3 col-6 text-muted">
                                        {type || "Tipo não informado"}
                                    </div>

                                    <div className="col-md-5 col-6 text-muted">
                                        {email || "Email não informado"}
                                    </div>
                                    </div>
                                </div>
                                </button>
                            </h2>

                            <div
                                id={`collapseUser${index}`}
                                className="accordion-collapse collapse"
                                data-bs-parent="#userAccordion"
                            >
                                <div className="accordion-body">
                                <div className="row mb-2">
                                    <div className="col-sm-5 fw-bold">Data de cadastro:</div>
                                    <div className="col-sm-7">
                                    {registration || "Não informado"}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-5 fw-bold">Quando criou o imóvel grátis:</div>
                                    <div className="col-sm-7">
                                    {firstFreeProperty || "Não informado"}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-5 fw-bold">Quando criou o imóvel pago:</div>
                                    <div className="col-sm-7">
                                    {firstHighlightProperty || "Não informado"}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-5 fw-bold">Uso do site:</div>
                                    <div className="col-sm-7">
                                    {websiteUsage || "Não informado"}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-5 fw-bold">Uso do app:</div>
                                    <div className="col-sm-7">
                                    {appusage || "Não informado"}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <button 
                                            className="btn btn-primary"
                                            onClick={async () => {
                                            try {
                                                // Chama a função que dispara a Cloud Function
                                                const result = await sendRedefinitionPassword(email, userData);

                                                if (result.success && result.resetLink) {
                                                // Cria dinamicamente um <a> e clica nele
                                                const link = document.createElement("a");
                                                link.href = result.resetLink;
                                                link.target = "_blank";
                                                link.rel = "noopener noreferrer";
                                                link.click();
                                                } else {
                                                alert("Erro ao gerar link: " + result.error);
                                                }
                                            } catch (err) {
                                                console.error(err);
                                                alert("Erro inesperado ao gerar link de redefinição.");
                                            }
                                            }}
                                        >
                                            Alterar Senha
                                        </button>
                                    </div>
                                </div>
                                    <div className="col">
                                        {/* aqui preciso que quando chamar o sendRedefinitionPassword acesse o link e retorne um a href parao  reset link _blank */}
                                    </div>
                                </div>
                            </div>
                            </div>
                        );
                        })}
                    </div>
                    </div>
                </section>
                )}

        </main>
    </div>
}